module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid38_960x879.2baa49d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid38_960x879.jpg
// module id = IAmW
// module chunks = 0